var _defs, _g, _g2, _path, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _path2, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitEntryIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "recruit_entry_icon5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 269.617,
    height: 381.064,
    viewBox: "0 0 269.617 381.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131895",
    "data-name": "\\uD328\\uC2A4 131895",
    d: "M552.728,308.18V251.253c0-23.251,17.358-42.167,38.693-42.167a35.748,35.748,0,0,1,18.16,5.029l7.119,4.143c26.284,15.3,42.614,44.886,42.614,77.225v69.874Z",
    transform: "translate(-552.728 -209.086)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184107",
    "data-name": "\\uADF8\\uB8F9 184107",
    transform: "translate(185.786 176.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131877",
    "data-name": "\\uD328\\uC2A4 131877",
    d: "M668.926,488.424l16.913-14.175V285.826l-16.913,14.18Z",
    transform: "translate(-668.125 -285.024)",
    fill: "#d8c7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131878",
    "data-name": "\\uD328\\uC2A4 131878",
    d: "M686.438,285.371a.613.613,0,0,0-.809.015L668.715,299.52a1.256,1.256,0,0,0-.388.956v187.84a1.239,1.239,0,0,0,.406.971.617.617,0,0,0,.809-.017l16.913-14.134a1.241,1.241,0,0,0,.389-.952V286.34A1.245,1.245,0,0,0,686.438,285.371Zm-1.2,188.181-15.308,12.792V301.1l15.308-12.794Z",
    transform: "translate(-668.327 -285.226)",
    fill: "#111"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184108",
    "data-name": "\\uADF8\\uB8F9 184108",
    transform: "translate(162.461 173.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131879",
    "data-name": "\\uD328\\uC2A4 131879",
    d: "M651.48,470.892l23.323,18.3V301.854l-23.323-18.3Z",
    transform: "translate(-650.677 -282.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131880",
    "data-name": "\\uD328\\uC2A4 131880",
    d: "M675.4,301.342,652.077,283.1a.616.616,0,0,0-.8.009,1.237,1.237,0,0,0-.4.956V470.843a1.226,1.226,0,0,0,.408.963l23.323,18.245a.65.65,0,0,0,.4.142.64.64,0,0,0,.405-.15,1.247,1.247,0,0,0,.4-.958V302.307A1.233,1.233,0,0,0,675.4,301.342Zm-1.2,185.845L652.485,470.2V285.963l21.72,16.988Z",
    transform: "translate(-650.879 -282.957)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184109",
    "data-name": "\\uADF8\\uB8F9 184109",
    transform: "translate(163.763 200.044)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131881",
    "data-name": "\\uD328\\uC2A4 131881",
    d: "M651.88,346.555,674.189,359.2l17.548,19.144V302.567L651.853,326.9Z",
    transform: "translate(-651.853 -302.567)",
    fill: "#32303c"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184110",
    "data-name": "\\uADF8\\uB8F9 184110",
    transform: "translate(16.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131882",
    "data-name": "\\uD328\\uC2A4 131882",
    d: "M745.717,165.114l-8.806-5.131a46.03,46.03,0,0,0-23.4-6.453,43.127,43.127,0,0,0-18.909,4.33C677.3,166.242,576.92,221,570.512,224.286c-16.727,8.571-28.324,26.99-28.324,48.277v57.069a10.886,10.886,0,0,0,5.568,9.7l108.031,57.956a9.364,9.364,0,0,0,4.462,1.136c5.536,0,10.036-4.862,10.036-10.838l104.952-56.5c1.406.755,7.02,2.691,8.575,2.691,5.535,0,10.034-4.861,10.034-10.837V252.148C793.846,215.741,775.405,182.394,745.717,165.114Z",
    transform: "translate(-541.386 -152.728)",
    fill: "#ffaad4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131883",
    "data-name": "\\uD328\\uC2A4 131883",
    d: "M746.323,164.624l-8.807-5.132a46.829,46.829,0,0,0-23.807-6.561,43.817,43.817,0,0,0-19.258,4.412c-12.073,5.85-65.445,34.738-97.334,52-14.418,7.8-24.836,13.442-26.769,14.433-17.47,8.952-28.76,28.181-28.76,48.991v57.069a11.686,11.686,0,0,0,5.992,10.406l108.029,57.953a10.134,10.134,0,0,0,4.842,1.234c5.826,0,10.592-4.961,10.83-11.153l104.175-56.083c1.908.88,6.973,2.594,8.557,2.594,5.977,0,10.838-5.223,10.838-11.64V252.353C794.851,215.66,776.257,182.044,746.323,164.624Zm46.924,158.521c0,5.535-4.143,10.035-9.234,10.035-1.336,0-6.794-1.844-8.2-2.6a.812.812,0,0,0-.759,0l-104.949,56.5a.8.8,0,0,0-.422.7c0,5.535-4.143,10.036-9.235,10.036a8.542,8.542,0,0,1-4.083-1.043L548.336,338.827a10.082,10.082,0,0,1-5.143-8.993V272.765c0-20.213,10.945-38.884,27.886-47.563,1.952-1,12.374-6.64,26.8-14.45,31.878-17.255,85.23-46.134,97.27-51.965a42.2,42.2,0,0,1,18.558-4.253,45.218,45.218,0,0,1,23,6.345l8.807,5.132h0c29.44,17.133,47.73,50.218,47.73,86.341Z",
    transform: "translate(-541.588 -152.93)",
    fill: "#111"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184112",
    "data-name": "\\uADF8\\uB8F9 184112",
    transform: "translate(56.636 4.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184111",
    "data-name": "\\uADF8\\uB8F9 184111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131884",
    "data-name": "\\uD328\\uC2A4 131884",
    d: "M711.742,156.744q-1.931-.453-3.893-.734a1.2,1.2,0,0,0-.734.134l-134.781,72.9a1.167,1.167,0,0,0-.469,1.59l1.186,2.168a1.171,1.171,0,0,0,1.583.467l137.391-74.356A1.173,1.173,0,0,0,711.742,156.744Z",
    transform: "translate(-571.72 -155.998)",
    fill: "#ffebb9"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184114",
    "data-name": "\\uADF8\\uB8F9 184114",
    transform: "translate(75.834 10.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184113",
    "data-name": "\\uADF8\\uB8F9 184113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131885",
    "data-name": "\\uD328\\uC2A4 131885",
    d: "M727.411,164.667a.411.411,0,0,1-.04-.024l-5.85-3.4a2.708,2.708,0,0,0-2.663-.036L587.5,232.919a2.713,2.713,0,0,0-1.08,3.684l2.785,5.089a2.712,2.712,0,0,0,3.68,1.08l134.432-73.4A2.711,2.711,0,0,0,727.411,164.667Z",
    transform: "translate(-586.081 -160.874)",
    fill: "#ffebb9"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184115",
    "data-name": "\\uADF8\\uB8F9 184115",
    transform: "translate(24.027 71.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131886",
    "data-name": "\\uD328\\uC2A4 131886",
    d: "M619.132,216.513l-7.117-4.143c-28.955-16.851-64.087,5.787-64.087,41.3v57.069a4.461,4.461,0,0,0,2.27,3.952l108.031,57.956c2.718,1.457,5.909-.678,5.909-3.954V297.9C664.138,263.9,646.855,232.644,619.132,216.513Z",
    transform: "translate(-547.126 -205.844)",
    fill: "#ffebb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131887",
    "data-name": "\\uD328\\uC2A4 131887",
    d: "M619.738,216.03l-7.119-4.142a40.809,40.809,0,0,0-41.825-.134c-14.693,8.449-23.466,24.2-23.466,42.125v57.069a5.237,5.237,0,0,0,2.692,4.659l108.032,57.954a4.62,4.62,0,0,0,4.589-.108,5.222,5.222,0,0,0,2.5-4.552V298.108C665.143,263.779,647.744,232.328,619.738,216.03Zm43.8,152.872a3.627,3.627,0,0,1-1.721,3.174,2.986,2.986,0,0,1-3.008.073L550.781,314.195a3.684,3.684,0,0,1-1.849-3.246V253.88c0-17.346,8.473-32.574,22.662-40.733a39.229,39.229,0,0,1,40.22.128l7.115,4.142c27.517,16.012,44.608,46.931,44.608,80.692Z",
    transform: "translate(-547.328 -206.056)",
    fill: "#111"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184116",
    "data-name": "\\uADF8\\uB8F9 184116",
    transform: "translate(30.444 74.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131888",
    "data-name": "\\uD328\\uC2A4 131888",
    d: "M616.7,218.258l-7.119-4.143a35.748,35.748,0,0,0-18.16-5.029c-21.335,0-38.693,18.917-38.693,42.167V308.18l106.585,57.178V295.483C659.313,263.145,642.984,233.555,616.7,218.258Z",
    transform: "translate(-551.926 -208.283)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131889",
    "data-name": "\\uD328\\uC2A4 131889",
    d: "M617.3,217.768l-7.115-4.143a36.545,36.545,0,0,0-18.565-5.14c-21.779,0-39.495,19.278-39.495,42.971v56.926a.8.8,0,0,0,.424.706l106.583,57.178a.8.8,0,0,0,.792-.019.8.8,0,0,0,.39-.687V295.686C660.316,263.065,643.835,233.209,617.3,217.768ZM658.712,364.22,553.732,307.9V251.456c0-22.81,17-41.367,37.891-41.367a34.945,34.945,0,0,1,17.756,4.922l7.119,4.14c26.037,15.156,42.214,44.48,42.214,76.534Z",
    transform: "translate(-552.128 -208.485)",
    fill: "#111"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184127",
    "data-name": "\\uADF8\\uB8F9 184127",
    transform: "translate(31.246 75.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184126",
    "data-name": "\\uADF8\\uB8F9 184126",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184125",
    "data-name": "\\uADF8\\uB8F9 184125",
    transform: "translate(44.917 15.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184117",
    "data-name": "\\uADF8\\uB8F9 184117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131890",
    "data-name": "\\uD328\\uC2A4 131890",
    d: "M705.713,229.819a10.125,10.125,0,0,0-11.57-8.437l-98.654,15.457a10.124,10.124,0,0,0-8.437,11.571l8.982,57.339a10.13,10.13,0,0,0,11.573,8.438l98.654-15.457a10.128,10.128,0,0,0,8.437-11.573Z",
    transform: "translate(-586.124 -220.456)",
    fill: "#ffbf17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131891",
    "data-name": "\\uD328\\uC2A4 131891",
    d: "M706.709,229.9a10.926,10.926,0,0,0-12.488-9.105l-98.654,15.457a10.928,10.928,0,0,0-9.107,12.489l8.984,57.339a10.937,10.937,0,0,0,10.775,9.238,11.422,11.422,0,0,0,1.713-.132l98.656-15.457h0a10.942,10.942,0,0,0,9.105-12.489Zm-.37,68.243L607.685,313.6a9.324,9.324,0,0,1-10.655-7.767l-8.982-57.342a9.324,9.324,0,0,1,7.766-10.653l98.655-15.457a9.349,9.349,0,0,1,1.464-.115,9.326,9.326,0,0,1,9.191,7.882l8.985,57.339A9.337,9.337,0,0,1,706.339,298.14Z",
    transform: "translate(-586.327 -220.658)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184118",
    "data-name": "\\uADF8\\uB8F9 184118",
    transform: "translate(0.569 9.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131892",
    "data-name": "\\uD328\\uC2A4 131892",
    d: "M706.566,227.569l-1.585.247.483,3.075a12.668,12.668,0,0,1-4.115,11.477L660.1,279.033a12.747,12.747,0,0,1-13.569,2.139l-50.692-22.277a12.668,12.668,0,0,1-7.448-9.676l-.056-.361-1.586.247.056.364a14.26,14.26,0,0,0,8.389,10.894l50.691,22.277a14.342,14.342,0,0,0,15.279-2.408l41.246-36.666a14.265,14.265,0,0,0,4.635-12.922Z",
    transform: "translate(-586.752 -227.569)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184119",
    "data-name": "\\uADF8\\uB8F9 184119",
    transform: "translate(101.378 35.854)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154149",
    "data-name": "\\uC0AC\\uAC01\\uD615 154149",
    width: 1.605,
    height: 32.149,
    transform: "matrix(0.615, -0.789, 0.789, 0.615, 0, 1.266)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184120",
    "data-name": "\\uADF8\\uB8F9 184120",
    transform: "translate(7.57 47.873)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154150",
    "data-name": "\\uC0AC\\uAC01\\uD615 154150",
    width: 32.147,
    height: 1.603,
    transform: "matrix(0.563, -0.827, 0.827, 0.563, 0, 26.574)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184121",
    "data-name": "\\uADF8\\uB8F9 184121",
    transform: "translate(16.947 73.587)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154151",
    "data-name": "\\uC0AC\\uAC01\\uD615 154151",
    width: 18.677,
    height: 11.425,
    transform: "matrix(0.988, -0.155, 0.155, 0.988, 0, 2.889)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184124",
    "data-name": "\\uADF8\\uB8F9 184124",
    transform: "translate(26.599 73.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184122",
    "data-name": "\\uADF8\\uB8F9 184122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131893",
    "data-name": "\\uD328\\uC2A4 131893",
    d: "M628.565,276.509a4.946,4.946,0,0,0-5.711.9,3.346,3.346,0,0,1-3.971.62,4.93,4.93,0,0,0-5.7.9,3.341,3.341,0,0,1-3.964.622,4.7,4.7,0,0,0-2.993-.476l.247,1.585a3.106,3.106,0,0,1,2.086.35,4.849,4.849,0,0,0,2.164.544,5.222,5.222,0,0,0,.83-.068,4.72,4.72,0,0,0,2.708-1.369,3.332,3.332,0,0,1,3.964-.62,4.937,4.937,0,0,0,5.706-.894,3.355,3.355,0,0,1,3.976-.622,4.747,4.747,0,0,0,3,.473l-.246-1.586A3.155,3.155,0,0,1,628.565,276.509Z",
    transform: "translate(-606.223 -275.969)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184123",
    "data-name": "\\uADF8\\uB8F9 184123",
    transform: "translate(0.634 4.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131894",
    "data-name": "\\uD328\\uC2A4 131894",
    d: "M629.039,279.532a4.943,4.943,0,0,0-5.712.9,3.143,3.143,0,0,1-1.882.975,3.108,3.108,0,0,1-2.087-.353,4.927,4.927,0,0,0-5.7.893,3.329,3.329,0,0,1-3.962.622,4.714,4.714,0,0,0-2.995-.476l.246,1.585a3.11,3.11,0,0,1,2.085.352,4.852,4.852,0,0,0,2.166.543,5.4,5.4,0,0,0,.83-.065,4.731,4.731,0,0,0,2.707-1.37,3.334,3.334,0,0,1,3.963-.622,4.938,4.938,0,0,0,5.708-.892,3.354,3.354,0,0,1,3.974-.624,4.736,4.736,0,0,0,3,.475l-.247-1.586A3.126,3.126,0,0,1,629.039,279.532Z",
    transform: "translate(-606.697 -278.992)",
    fill: "#111"
  }))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184128",
    "data-name": "\\uADF8\\uB8F9 184128",
    transform: "translate(0 174.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131896",
    "data-name": "\\uD328\\uC2A4 131896",
    d: "M534.868,353.673c-11.5,32.28-2.457,61.819,23.6,77.09l7.055,4.134a38.951,38.951,0,0,0,19.973,5.023c25.564,0,53.087-18.885,61.358-42.1L667.094,341,559.716,283.921Z",
    transform: "translate(-529.152 -283.12)",
    fill: "#ffaad4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131897",
    "data-name": "\\uD328\\uC2A4 131897",
    d: "M667.675,340.492,560.3,283.416a.8.8,0,0,0-1.134.438L534.316,353.6c-11.636,32.666-2.461,62.575,23.948,78.051l7.053,4.135a39.747,39.747,0,0,0,20.379,5.132c25.875,0,53.738-19.122,62.112-42.629l20.245-56.825A.808.808,0,0,0,667.675,340.492ZM646.3,397.756c-8.164,22.918-35.352,41.563-60.6,41.563a38.18,38.18,0,0,1-19.566-4.912l-7.056-4.135c-25.7-15.064-34.609-44.235-23.248-76.129l24.537-68.875,105.945,56.314Z",
    transform: "translate(-529.355 -283.322)",
    fill: "#111"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184129",
    "data-name": "\\uADF8\\uB8F9 184129",
    transform: "translate(11.186 193.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131898",
    "data-name": "\\uD328\\uC2A4 131898",
    d: "M644.333,338.22,571.31,299.4A8.014,8.014,0,0,0,560,303.787l-17.371,48.755c-9.719,27.287-2.729,51.076,18.7,63.633l7.055,4.135a27.935,27.935,0,0,0,14.3,3.481c20.835,0,44.09-15.861,50.778-34.635l14.669-41.171A8.015,8.015,0,0,0,644.333,338.22Z",
    transform: "translate(-537.519 -297.661)",
    fill: "#ff7ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131899",
    "data-name": "\\uD328\\uC2A4 131899",
    d: "M644.913,337.713l-73.023-38.818a8.819,8.819,0,0,0-12.446,4.826l-17.367,48.754c-9.861,27.678-2.741,51.826,19.046,64.6l7.055,4.134a28.723,28.723,0,0,0,14.7,3.592c21.142,0,44.742-16.105,51.535-35.169l14.667-41.17A8.867,8.867,0,0,0,644.913,337.713Zm2.655,10.2L632.9,389.088c-6.583,18.486-29.491,34.1-50.021,34.1a27.136,27.136,0,0,1-13.889-3.372l-7.056-4.132c-21.069-12.351-27.927-35.78-18.346-62.673l17.369-48.757a7.213,7.213,0,0,1,10.179-3.948l73.025,38.819A7.253,7.253,0,0,1,647.568,347.917Z",
    transform: "translate(-537.723 -297.862)",
    fill: "#111"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184130",
    "data-name": "\\uADF8\\uB8F9 184130",
    transform: "translate(9.358 196.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131900",
    "data-name": "\\uD328\\uC2A4 131900",
    d: "M636.74,338.28,568,301.742a7.543,7.543,0,0,0-10.647,4.13l-16.347,45.892c-9.151,25.685-2.571,48.078,17.6,59.9l6.642,3.892A26.285,26.285,0,0,0,578.7,418.83c19.613,0,41.5-14.93,47.8-32.6l13.806-38.756A7.54,7.54,0,0,0,636.74,338.28Z",
    transform: "translate(-536.151 -300.057)",
    fill: "#ffebb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131901",
    "data-name": "\\uD328\\uC2A4 131901",
    d: "M637.32,337.773l-68.736-36.536A8.342,8.342,0,0,0,556.8,305.8l-16.35,45.891c-9.29,26.077-2.577,48.828,17.951,60.859l6.639,3.89a27.059,27.059,0,0,0,13.862,3.389c19.918,0,42.153-15.175,48.552-33.135l13.807-38.754A8.4,8.4,0,0,0,637.32,337.773Zm2.436,9.632-13.808,38.756c-6.191,17.383-27.735,32.069-47.04,32.069a25.48,25.48,0,0,1-13.05-3.168l-6.639-3.892c-19.812-11.609-26.26-33.641-17.251-58.934l16.35-45.892a6.738,6.738,0,0,1,9.514-3.691l68.737,36.536A6.786,6.786,0,0,1,639.756,347.4Z",
    transform: "translate(-536.355 -300.259)",
    fill: "#111"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184134",
    "data-name": "\\uADF8\\uB8F9 184134",
    transform: "translate(97.223 205.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184131",
    "data-name": "\\uADF8\\uB8F9 184131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131902",
    "data-name": "\\uD328\\uC2A4 131902",
    d: "M634.816,322.4,607.891,307.92a3.228,3.228,0,0,0-3.095.02l-.458.255a3.224,3.224,0,0,0,.008,5.642l26.636,14.7a3.2,3.2,0,0,0,2.759.14l-.961-1.87.838-.762,1.41,1.908a3.222,3.222,0,0,0-.213-5.552Z",
    transform: "translate(-601.878 -306.732)",
    fill: "#d8c7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131903",
    "data-name": "\\uD328\\uC2A4 131903",
    d: "M635.4,321.9l-26.923-14.481a4.015,4.015,0,0,0-3.864.025l-.458.255a4.027,4.027,0,0,0,.009,7.045l26.637,14.7a3.924,3.924,0,0,0,1.9.488,4.126,4.126,0,0,0,1.548-.3.806.806,0,0,0,.451-.464.785.785,0,0,0,.044-.372.8.8,0,0,0,.925.041,4.024,4.024,0,0,0-.267-6.934Zm-.037,5.085-.9-1.211a.789.789,0,0,0-.565-.321.845.845,0,0,0-.619.2l-.837.763a.8.8,0,0,0-.175.96l.488.946a2.379,2.379,0,0,1-1.183-.285l-26.637-14.7a2.424,2.424,0,0,1-.007-4.239l.461-.254a2.4,2.4,0,0,1,2.324-.016l26.926,14.482a2.418,2.418,0,0,1,.721,3.672Z",
    transform: "translate(-602.08 -306.934)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184132",
    "data-name": "\\uADF8\\uB8F9 184132",
    transform: "translate(20.67 11.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131904",
    "data-name": "\\uD328\\uC2A4 131904",
    d: "M617.6,321.976l1.592-.193a4.3,4.3,0,0,1,3.735-5.028l-.23-1.588A5.881,5.881,0,0,0,617.6,321.976Z",
    transform: "translate(-617.542 -315.167)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184133",
    "data-name": "\\uADF8\\uB8F9 184133",
    transform: "translate(10.499 5.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131905",
    "data-name": "\\uD328\\uC2A4 131905",
    d: "M609.993,317.952l1.592-.193a4.3,4.3,0,0,1,3.735-5.028l-.231-1.587A5.875,5.875,0,0,0,609.993,317.952Z",
    transform: "translate(-609.933 -311.145)",
    fill: "#111"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184138",
    "data-name": "\\uADF8\\uB8F9 184138",
    transform: "translate(44.079 177.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184135",
    "data-name": "\\uADF8\\uB8F9 184135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131906",
    "data-name": "\\uD328\\uC2A4 131906",
    d: "M595.063,301.459l-26.924-14.482a3.228,3.228,0,0,0-3.095.021l-.459.254a3.227,3.227,0,0,0,.008,5.644l26.637,14.7a3.2,3.2,0,0,0,2.759.143l-.964-1.87.838-.765,1.412,1.908a3.222,3.222,0,0,0-.213-5.552Z",
    transform: "translate(-562.125 -285.788)",
    fill: "#d8c7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131907",
    "data-name": "\\uD328\\uC2A4 131907",
    d: "M595.646,300.957,568.72,286.475a4,4,0,0,0-3.864.025l-.459.255a4.027,4.027,0,0,0,.011,7.045l26.636,14.7a3.912,3.912,0,0,0,1.9.488,4.114,4.114,0,0,0,1.544-.3.8.8,0,0,0,.453-.464.513.513,0,0,1,.969-.329,4.027,4.027,0,0,0-.266-6.934Zm-.039,5.085-.9-1.212a.8.8,0,0,0-1.183-.116l-.84.761a.8.8,0,0,0-.172.963l.485.947a2.273,2.273,0,0,1-1.182-.289l-26.636-14.7a2.425,2.425,0,0,1-.007-4.241l.461-.254a2.406,2.406,0,0,1,2.322-.015l26.927,14.482a2.423,2.423,0,0,1,.721,3.672Z",
    transform: "translate(-562.327 -285.991)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184136",
    "data-name": "\\uADF8\\uB8F9 184136",
    transform: "translate(20.671 11.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131908",
    "data-name": "\\uD328\\uC2A4 131908",
    d: "M577.849,301.033l1.592-.194a4.3,4.3,0,0,1,3.735-5.025l-.233-1.588A5.875,5.875,0,0,0,577.849,301.033Z",
    transform: "translate(-577.789 -294.226)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184137",
    "data-name": "\\uADF8\\uB8F9 184137",
    transform: "translate(10.497 5.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131909",
    "data-name": "\\uD328\\uC2A4 131909",
    d: "M570.239,297.01l1.595-.193a4.3,4.3,0,0,1,3.732-5.028l-.229-1.587A5.878,5.878,0,0,0,570.239,297.01Z",
    transform: "translate(-570.179 -290.203)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184139",
    "data-name": "\\uADF8\\uB8F9 184139",
    transform: "translate(145.51 133.595)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131910",
    "data-name": "\\uD328\\uC2A4 131910",
    d: "M638.2,353.413l104.694-55.786V252.862L638.2,309.175Z",
    transform: "translate(-638.2 -252.862)",
    fill: "#32303c"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184140",
    "data-name": "\\uADF8\\uB8F9 184140",
    transform: "translate(163.848 92.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131911",
    "data-name": "\\uD328\\uC2A4 131911",
    d: "M682.777,224.564c-19.574,7.016-32.922,29.6-29.812,50.449s21.5,32.062,41.072,25.047,32.922-29.6,29.812-50.449S702.353,217.55,682.777,224.564Z",
    transform: "translate(-651.715 -221.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131912",
    "data-name": "\\uD328\\uC2A4 131912",
    d: "M709.9,226.035c-7.932-4.746-17.59-5.462-27.193-2.023-19.885,7.125-33.5,30.149-30.337,51.324,1.556,10.421,6.862,18.824,14.943,23.662a29.535,29.535,0,0,0,15.294,4.167,35.261,35.261,0,0,0,11.9-2.146c19.883-7.125,33.492-30.149,30.335-51.322C723.291,239.275,717.982,230.872,709.9,226.035Zm-15.933,73.474c-9.148,3.277-18.319,2.607-25.831-1.886-7.66-4.587-12.7-12.587-14.177-22.523-3.051-20.455,10.087-42.7,29.288-49.576a33.67,33.67,0,0,1,11.355-2.049,27.951,27.951,0,0,1,14.474,3.938C716.74,232,721.774,240,723.258,249.934,726.308,270.391,713.169,292.629,693.969,299.509Z",
    transform: "translate(-651.917 -221.868)",
    fill: "#111"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184141",
    "data-name": "\\uADF8\\uB8F9 184141",
    transform: "translate(177.931 114.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131913",
    "data-name": "\\uD328\\uC2A4 131913",
    d: "M682.495,270.711l-13.365-9.886-6.679,9.028,18.593,13.755a5.611,5.611,0,0,0,3.339,1.1,5.68,5.68,0,0,0,1.235-.136,5.616,5.616,0,0,0,3.718-2.836l20.308-38.04-9.909-5.287Z",
    transform: "translate(-662.451 -238.408)",
    fill: "#00c481"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184142",
    "data-name": "\\uADF8\\uB8F9 184142",
    transform: "translate(249.402 116.707)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154152",
    "data-name": "\\uC0AC\\uAC01\\uD615 154152",
    width: 1.605,
    height: 61.654,
    fill: "#111"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184143",
    "data-name": "\\uADF8\\uB8F9 184143",
    transform: "translate(144.413 206.033)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154153",
    "data-name": "\\uC0AC\\uAC01\\uD615 154153",
    width: 1.605,
    height: 29.052,
    fill: "#111"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184144",
    "data-name": "\\uADF8\\uB8F9 184144",
    transform: "translate(46.929 65.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131914",
    "data-name": "\\uD328\\uC2A4 131914",
    d: "M564.459,206.338l.791,1.394c.11-.063,11.068-6.143,26.53-4.1l.21-1.591C575.973,199.925,564.922,206.073,564.459,206.338Z",
    transform: "translate(-564.459 -201.601)",
    fill: "#111"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184145",
    "data-name": "\\uADF8\\uB8F9 184145",
    transform: "translate(37.099 204.95)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154154",
    "data-name": "\\uC0AC\\uAC01\\uD615 154154",
    width: 1.603,
    height: 101.508,
    transform: "translate(0 0.437) rotate(-15.798)",
    fill: "#111"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184146",
    "data-name": "\\uADF8\\uB8F9 184146",
    transform: "translate(17.73 241.898)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154155",
    "data-name": "\\uC0AC\\uAC01\\uD615 154155",
    width: 92.922,
    height: 1.603,
    transform: "translate(0 35.027) rotate(-22.145)",
    fill: "#111"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184147",
    "data-name": "\\uADF8\\uB8F9 184147",
    transform: "translate(45.919 254.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131915",
    "data-name": "\\uD328\\uC2A4 131915",
    d: "M571.444,344.089a7.14,7.14,0,1,0,7.141,7.14A7.14,7.14,0,0,0,571.444,344.089Z",
    transform: "translate(-563.502 -343.287)",
    fill: "#ffebb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131916",
    "data-name": "\\uD328\\uC2A4 131916",
    d: "M571.646,343.489a7.943,7.943,0,1,0,7.942,7.942A7.952,7.952,0,0,0,571.646,343.489Zm0,14.28a6.338,6.338,0,1,1,6.338-6.338A6.346,6.346,0,0,1,571.646,357.769Z",
    transform: "translate(-563.704 -343.489)",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitEntryIcon5);
export default __webpack_public_path__ + "static/media/recruit_entry_icon5.fe14fa72bc661dc6e60789cf03ad249b.svg";
export { ForwardRef as ReactComponent };